
document.addEventListener("DOMContentLoaded", () => {

  function swatchFun() {

    var swatchesEl = document.querySelectorAll(".product-card__aside .mw_swatch_varaint");
    if (swatchesEl[0]) {
      for (let i = 0; i < swatchesEl.length; i++) {
        swatchesEl[i].addEventListener("click",variantFun);
      }
      
      function variantFun(elm) {
        let curValue = this.getAttribute("swatch_var_id");
        let curVarId = this.getAttribute("variant_id");
        let productCardEl = elm.target.closest("product-card");

        let customSwatchEl = productCardEl.querySelector(`.custom_swatch [option1="${curValue}"]`);
        let minPrice = customSwatchEl.getAttribute("price1");
        let maxPrice = customSwatchEl.getAttribute("compare_price");

        let isSoldOut = customSwatchEl.getAttribute("cur_var_available");
        let soldOutBadgeEl = productCardEl.querySelector("sold-out-badge");
        soldOutBadgeEl.hidden = !isSoldOut;

        // Use the SaleBadge element to show Discount or SoldOut message
        let mwSaleBadgeEl = productCardEl.querySelector("on-sale-badge");
        mwSaleBadgeEl.hidden = isSoldOut || (minPrice == maxPrice);

        if (minPrice != maxPrice ) {
          // Update the discount percentage in the product badge
          let globalDisc = mwSaleBadgeEl.getAttribute('global-discounts');
          let extraDiscValue = (globalDisc != "0") ? (minPrice.replace(/[$€£,]/g, '') * globalDisc / 100) : 0.0;
          let disc = parseFloat((maxPrice.replace(/[$€£,]/g, '') - minPrice.replace(/[$€£,]/g, '') + extraDiscValue) * (100 / (maxPrice.replace(/[$€£,]/g, ''))));
          mwSaleBadgeEl.innerHTML = `Save ${disc.toFixed(0)}%`;

          // Update the price comparison underneath the product's title
          productCardEl.querySelector("price-list sale-price").innerHTML = `<span style="color: rgb(170 40 38); font-size: 17px; font-weight: 700;">${minPrice}</span>`;
          if (maxPrice) {
            if (productCardEl.querySelector("price-list compare-at-price")) {
              productCardEl.querySelector("price-list compare-at-price").innerHTML = `<span>${maxPrice}</span>`;
            } else {
              let maxPriceDiv = document.createElement('compare-at-price');
              maxPriceDiv.classList.add('text-subdued', 'line-through');
              maxPriceDiv.innerHTML = `<span>${maxPrice}</span>`;
              productCardEl.querySelector("price-list").append(maxPriceDiv);
            }
          }
        } else {
          productCardEl.querySelector("price-list sale-price").innerHTML = `<span style="font-size: 17px; color: #666868; font-weight: 700;">${minPrice}</span>`;
          if (productCardEl.querySelector("price-list compare-at-price")) {
            productCardEl.querySelector("price-list compare-at-price").innerHTML = ' ';
          }
        }

        // update grouped product image
        if (document.querySelector(".custom_swatch_grouped")) {
          let findVarDiv = curVarId ? productCardEl.querySelector(`.custom_swatch [groupprdid="${curVarId}"]`) : null;
          if (findVarDiv && findVarDiv.closest(".custom_swatch_grouped")) {

            // get product image
            let productImg = productCardEl.querySelectorAll(`.product-card__figure a img`);
            
            // update first image
            let variant_first_img = findVarDiv.getAttribute("varimg1");
            variant_first_img && productImg[0] ? productImg[0].setAttribute("srcset",variant_first_img) : null;
            
            // update secondary image
            let variant_second_img = findVarDiv.getAttribute("varimg2");
            variant_second_img && productImg[1] ? productImg[1].setAttribute("srcset",variant_second_img) : null;
            
            // update image link
            let prdCurUrl = elm.target.classList.contains("mw_swatch_varaint") ? elm.target.getAttribute("var_handle") :
            elm.target.classList.contains("color-swatch") ? elm.target.parentElement.getAttribute("var_handle") : null;
            prdCurUrl && productCardEl.querySelector(`.product-card__figure a`).setAttribute("href",prdCurUrl); 
            
            // Grouped Product Title change on swatch click on collections Page 
            if(elm.target.closest(".mw_swatch_varaint").getAttribute('data-prod_title')){
              let grpPrdTitle = elm.target.closest(".mw_swatch_varaint").getAttribute('data-prod_title');
              let titleToChange = elm.target.closest('.product-card__info').querySelector('.product-card__title a');

              if( titleToChange.innerText != grpPrdTitle ){
                titleToChange.innerHTML = grpPrdTitle;
              }
            }
          }
        }
      }
    }
  }
  swatchFun();

  /**
   * Our theme allows user to switch product variants listed on home page and collection page.
   * This function will iterate through available variants shown in the page, and will automatically select variants that's:
   *   - currently having discount
   *   - is in-stock
   */
  function selectPrioritizedVariants() {

    function getOpenedDrawer() {
      const drawerTags = ['search-drawer', 'navigation-drawer', 'cart-notification-drawer'];
      for (var i=0; i < drawerTags.length; i++) {
        let drawerElm = document.getElementsByTagName(drawerTags[i])[0];
        let drawerIsShown = drawerElm.style.visibility == "visible";
        if (drawerIsShown) {
          return drawerElm;
        }
      }
    }

    // Due to simulated clicks in this method, we need to pause the search and menu bar focus trap (anything that's deriven from Drawer object).
    // Otherwise any active Drawer objects will be automatically hidden when this function run (during full page load).
    let openedDrawerElm = getOpenedDrawer();
    if (openedDrawerElm) {
      openedDrawerElm.focusTrap.pause();
    }

    if (document.querySelector(".product-card__aside .mw_swatch_varaint")) {
      let prdList = document.querySelectorAll(".product-list product-card");
      prdList.forEach(elm => {

        // only update new loaded product 
        if (!elm.classList.contains("checkedDiv")) {
          elm.classList.add("checkedDiv")
        
          let [varAvailableDiv, varDiscountDiv] = [undefined, undefined];
          let varinatSpan = elm.querySelectorAll(".mw_swatch_varaint"); // get all variant swatches

          for (const el of varinatSpan) {
            let variantOption = el.getAttribute("swatch_var_id"); // get variant title
            let findVariant = elm.querySelector(`.custom_swatch [option1="${variantOption}"]`); // find varaint title in custom swatch div span

            if (!varAvailableDiv && findVariant && !findVariant.hasAttribute('cur_var_available')) {
              varAvailableDiv = findVariant; // assign available variant
            }
            if (findVariant && !findVariant.hasAttribute('cur_var_available') && findVariant.getAttribute('is_discount') === 'true') {
              varDiscountDiv = findVariant; // assign discounted variant
              break; // break loop when discounted variant find
            }
          }

          // for product page that's using Shopify variant-picker
          if (varAvailableDiv && elm.querySelector('[group__prd="false"]')){
            // click on swatched span
            function swatchClick(data) {
              elm.querySelector(`[swatch_var_id="${data.getAttribute("option1")}"]`).click();
            }
            swatchClick(document.querySelector('body.show_sale_badge') ? (varDiscountDiv || varAvailableDiv) : varAvailableDiv);

          }
          else if(elm.querySelector(".mw_swatch_varaint")) {
            elm.querySelector(".mw_swatch_varaint").click(); 
          }

          // for product page that's using Impact-theme grouped-product
          if(elm.querySelector('[group__prd="true"]')){
            let prdUrl = elm.querySelector(".product-card__title a").getAttribute("href");
            if (prdUrl) {
              prdUrl = prdUrl.indexOf("?") != -1 ? prdUrl.split('?')[0] : prdUrl;
              const groupPrd = elm.querySelectorAll('[group__prd="true"]');
              groupPrd.forEach(elm => {
                if (elm.getAttribute('var_handle').split('?')[0] === prdUrl) {
                  elm.click();
                }
              });
            }
          }
        }

      });

      if (openedDrawerElm) {  // Resume default Drawer behaviour
        openedDrawerElm.focusTrap.unpause();
      }
    }
  }
  // run first time code on site load
  setTimeout(() => {
    selectPrioritizedVariants();
  }, 1000);

  document.addEventListener('readystatechange', function() {
    if(document.readyState == "complete"){
      // check if product already checked then skip this
      if (document.querySelector("#Huratips-Loop") && !document.querySelector("#Huratips-Loop").lastElementChild.classList.contains("checkedDiv")) {
        selectPrioritizedVariants();
      }
    }
  })

  // update swatchFun and selectPrioritizedVariants function
  function reintilizeCode() {
    // check if product already checked then skip this
    if (!document.querySelector("#Huratips-Loop").lastElementChild.classList.contains("checkedDiv")) {
      setTimeout(() => {
        swatchFun();
        selectPrioritizedVariants();
        // check if product already checked then skip this
        if (!document.querySelector("#Huratips-Loop").lastElementChild.classList.contains("checkedDiv")) {
          setTimeout(() => {
            swatchFun();
            selectPrioritizedVariants();
            // check if product already checked then skip this
            if (!document.querySelector("#Huratips-Loop").lastElementChild.classList.contains("checkedDiv")) {
              setTimeout(() => {
                swatchFun();
                selectPrioritizedVariants();
              }, 1000);
            }
          }, 1000);
        }
      }, 1000);
    }
  }
  // sidebar fillter form
  document.querySelector("body").addEventListener("change", function(event) {
    if (event.target.closest("#facet-form")) {
     reintilizeCode();   
     setTimeout(() => {
      custom_ajax_pagination();
    }, 2000);   
    }
  });
  // sort by
  document.querySelector("body").addEventListener("click", function(event) {
    if (event.target.closest(".popover-listbox__option")) {      
      location.reload(); 
    }    
  });
  // remove fillter btn
  document.querySelector("body").addEventListener("click", function(event) {
    if (event.target.closest(".active-facets a")) {
      reintilizeCode();
      setTimeout(() => {
        custom_ajax_pagination();
      }, 2000);
    }
  });

  // pagination add save bade
  if (document.querySelector("#Huratips-Pagination")) {
    const PaginationEl = document.querySelector("#Huratips-Pagination");
    const PaginationOb = new MutationObserver(function(mutationsList, observer){
      reintilizeCode();
    });
  
    const domConfig = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData:true
    };  
    PaginationOb.observe(PaginationEl, domConfig);
  }
  
  // Backorder Message
  function backdoor() {
    // show hide shop pay
    setTimeout(() => {
      let regularPriceElement = document.querySelector(".product-info__price sale-price"); // get product price
      let regularPrice = regularPriceElement ? parseFloat(regularPriceElement.innerText.replace(/[^\d.]/g, '')) : null;

      let shopPayElement = document.querySelector('.product-info__payment-terms_main'); // Get the shopPay element
      let shopPay = shopPayElement ? shopPayElement : null;

      // show shop pay when product price is more than $50
      if (regularPrice && shopPay && regularPrice >= 50.00) { 
        if (document.querySelector('.shop_pay_hide')) {
          shopPay.classList.remove("shop_pay_hide")
        }
      }
      else if (regularPrice && shopPay && regularPrice < 50.00) {
        shopPay.classList.add("shop_pay_hide")
      }
    }, 0);
    // show hide shop pay

  }
  backdoor();
  
  $('.shopify-product-form').change(function(){
    backdoor();
  });

  // pagination autoscroll
  function custom_ajax_pagination() {
    //console.log('custom pagination');
    if (document.querySelector("#Huratips-Pagination")) {
      var endlessScroll = new Ajaxinate({
        container: '#Huratips-Loop',
        pagination: '#Huratips-Pagination'
      });
    }
  }
    custom_ajax_pagination();

  // hide dawn icon on mobile menu
  let shopByCategory = document.querySelectorAll("#bottom_end")
  let t = new IntersectionObserver(e => {
    e.forEach(e => {
      document.querySelector(".down_icon").classList.toggle("hide_dawn_icon");
    })
  });
  shopByCategory.forEach(e => {
    t.observe(e)
  })

  // banner section dynamic slider
  const bannerSlider = document.querySelectorAll(".custom_slide_banner_inner");
  // check banner existing
  if (bannerSlider[0]) {
    for (let i = 0; i < bannerSlider.length; i++) {
      if (bannerSlider[i].childElementCount > 1) {
        // get autoplay speed
        let autoPlaySpeed = bannerSlider[i].getAttribute("data-autoplayspeed")
        // integrated slick slider
        $(bannerSlider[i]).slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          autoplay: true,
          dots: true,
          autoplaySpeed: autoPlaySpeed,
          arrows: false
        });

      }
    }
  }

  
});


// let ctm__footer_text_note = document.createElement("div");
// ctm__footer_text_note.className = "ctm__footer_text_note";
// ctm__footer_text_note.innerHTML = `<span class="ctm__footer_text">We think you'll love these</span>`;
// setTimeout(()=>{
//   document.querySelector('.rebuy-cart__flyout-content.has-items').insertAdjacentElement('beforeend', ctm__footer_text_note);
// }, 2000);

// let ctm__footer_save = document.createElement("div");
// ctm__footer_save.className = "ctm__footer_rebuy_price_save";
// ctm__footer_save.innerHTML = `
// <div class="loading__spinner ctm_hidden ctm__loading__spinner">
//   <svg
//     aria-hidden="true"
//     focusable="false"
//     class="spinner"
//     viewBox="0 0 66 66"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//   </svg>
// </div>
// <div class="ctm__ctm__footer_rebuy_price_save_wrapper">
// <span class="ctm__prdDiscount"></span>
// <span class="ctm__prdDiscountGap"></span>
// </div>
// `;
// console.log("ctm_save", ctm__footer_save);
// setTimeout(()=>{
//   document.querySelector('.rebuy-cart__flyout-footer').insertBefore(ctm__footer_save, document.querySelector('.rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal').nextSibling);
// }, 2000);


// rebuy side cart
// remove currency symble from price
function extractNumericValue(str) {
  const numericStr = str.replace(/[^0-9.,]/g, '');
  const numericValue = parseFloat(numericStr.replace(/,/g, ''));
  return numericValue;
}

// show total compare price and total discount
function calculateDiscountPercentagesFromHTML(rbCartEvent) {
  let saleTotal = 0;
  let compareTotal = 0;
  const items = document.querySelectorAll('.rebuy-cart__flyout-item');

  function getSalePrice(element) {
    let salePrice = element.querySelector(".rebuy-money.sale > :last-child") || element.querySelector(".rebuy-money > :last-child");
    let salePriceVal = salePrice ? extractNumericValue(salePrice.innerText) : null;
    return salePriceVal;
  }

  function getCompareAtPrice(element, salePriceVal) {
    // If we have additional discount applied to a product, we can't get the original 'compare_at_price' in the rbCartEvent items.
    // Ex: Compare at price = 399, original price = 359, final price (extra discount) = 314.
    let comparePrice = element.querySelector(".rebuy-money.compare-at > :last-child");
    let comparePriceVal = comparePrice ? extractNumericValue(comparePrice.innerText) : salePriceVal;
    return comparePriceVal;
  }

  if (rbCartEvent) {
    // We're using product quantity from the event, since we can't get real-time qty from using element.querySelector.
    // If we use code block from other code path, we'll get product qty before cart change.
    const rbCart = rbCartEvent.detail.cart;
    const cartItems = rbCart.items();
    for (let idx = 0; idx < cartItems.length; idx++) {
      const itemEl = items[idx];
      const cartItem = cartItems[idx];
      const salePrice = getSalePrice(itemEl);
      const compareAtPrice = getCompareAtPrice(itemEl, salePrice);
      saleTotal += cartItem.quantity * salePrice;
      compareTotal += cartItem.quantity * compareAtPrice;
    }
  } else {
    // Called on initial page load, when 'rebuy.cart:change' event not yet called.
    // TODO: Might need to refactor this code block. Try to use Rebuy cart event instead.
    items.forEach(itemEl => {
      let prdQtyEl = itemEl.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
      let prdQty = parseInt(prdQtyEl.innerText);
      prdQty = typeof prdQty == 'string' ? parseInt(prdQty) : prdQty;

      const salePrice = getSalePrice(itemEl);
      const compareAtPrice = getCompareAtPrice(itemEl, salePrice);
      saleTotal += prdQty * salePrice;
      compareTotal += prdQty * compareAtPrice;

    });
  }

  function formatMoney(value) {
    // When 'value' is whole number, need to convert them to cents before we pass them to formatMoney function
    if (value % 1 == 0) {
      return Rebuy.Cart.formatMoney(value * 100);
    } else {
      return Rebuy.Cart.formatMoney(value);
    }
  }

  // display order value
  const orderVal = document.querySelector('.rebuy-cart__flyout-subtotal.rebuy-order-value .rebuy-cart__flyout-subtotal-amount');
  if (orderVal && compareTotal) orderVal.innerText = `${formatMoney(compareTotal)}`;

  // display discount value
  const discountVal = document.querySelector('.rebuy-cart__flyout-subtotal.rebuy-discount-value .rebuy-cart__flyout-subtotal-amount');
  const discountAmount = compareTotal - saleTotal;
  if (discountVal && compareTotal && saleTotal) discountVal.innerText = `-${formatMoney(discountAmount)}`;
}


// check rebuy side integrate or note
const siteBody = document.querySelector("body");
const siteBodyOb = new MutationObserver(function(mutationsList, observer){
  if (document.querySelector(".rebuy-cart__flyout-subtotal-amount")) {
    siteBodyOb.disconnect(); // disconnect MutationObserver
    setTimeout(calculateDiscountPercentagesFromHTML, 300)

    // update side cart when user click on cart icon
    document.querySelector('.header__icon-list [aria-controls="cart-drawer"]').addEventListener('click', () => setTimeout(calculateDiscountPercentagesFromHTML, 300));

    document.addEventListener('rebuy:cart.change', (event) => {
      document.querySelector('.header__icon-list [aria-controls="cart-drawer"] .count-bubble').innerText = event.detail.cart.cart.item_count;
      document.querySelector('.header__icon-list [aria-controls="cart-drawer"] .count-bubble').style.opacity = event.detail.cart.cart.item_count === 0 ? 0 : 1;
      calculateDiscountPercentagesFromHTML(event);
    });

    // TODO: See if we can remove this observer, as it's constantly updating the subtotal element continously.
    //       Last time I tried to remove this, there's strange bug when the Order value, Discount, and Shipping element are not rendered.
    // detect side cart changes
    const rebuyTotalPrice = document.querySelector(".rebuy-cart__flyout-subtotal-amount");
    const rebuyTotalPriceOb = new MutationObserver(function(mutationsList, observer){
      setTimeout(calculateDiscountPercentagesFromHTML, 300)
    });

    rebuyTotalPriceOb.observe(rebuyTotalPrice, domConfig);
  }
});

const domConfig = {
  childList: true
};  
siteBodyOb.observe(siteBody, domConfig);